import {defineMessages} from 'react-intl';

export const trMessages = {
    readAloudTitle: {
        id: 'gui.debugModal.readAloud.title',
        defaultMessage: 'Sesli Oku',
        description: 'title for the "read aloud" section'
    },
    readAloudDescription1: {
        id: 'gui.debugModal.readAloud.description1',
        defaultMessage: 'Kodunuzu sesli okurken, bilgisayarın bakış açısından düşünün.',
        description: 'description for the "read aloud" section of the debug modal'
    },
    readAloudDescription2: {
        id: 'gui.debugModal.readAloud.description2',
        defaultMessage: 'Var olmayan adımları dahil ediyor musunuz?',
        description: 'description for the "read aloud" section of the debug modal'
    },
    readAloudDescription3: {
        id: 'gui.debugModal.readAloud.description3',
        defaultMessage: 'Talimatlarınız açık mı?',
        description: 'description for the "read aloud" section of the debug modal'
    },
    readAloudDescription4: {
        id: 'gui.debugModal.readAloud.description4',
        defaultMessage: 'Program her çalıştığında bir şeyin sıfırlanması gerekiyorsa, bu talimatlar dahil edilmiş mi?',
        description: 'description for the "read aloud" section of the debug modal'
    },
    breakItDownTitle: {
        id: 'gui.debugModal.breakItDown.title',
        defaultMessage: 'Parçalara Ayır',
        description: 'title for the "break it down" section'
    },
    breakItDownDescription1: {
        id: 'gui.debugModal.breakItDown.description1',
        defaultMessage: 'Blokları daha küçük parçalara (veya dizilere) ayırın ve her dizinin ne yaptığını görmek için tıklayın.',
        description: 'description for the "break it down" section of the debug modal'
    },
    breakItDownDescription2: {
        id: 'gui.debugModal.breakItDown.description2',
        defaultMessage: 'Daha küçük diziler beklediğiniz gibi çalışınca, bunları ana programa geri ekleyin.',
        description: 'description for the "break it down" section of the debug modal'
    },
    breakItDownDescription3: {
        id: 'gui.debugModal.breakItDown.description3',
        defaultMessage: 'Bu işleme ayrıştırma denir.',
        description: 'description for the "break it down" section of the debug modal'
    },
    slowItDownTitle: {
        id: 'gui.debugModal.slowItDown.title',
        defaultMessage: 'Yavaşlat',
        description: 'title for the "slow it down" section'
    },
    slowItDownDescription1: {
        id: 'gui.debugModal.slowItDown.description1',
        defaultMessage: 'Bilgisayar programınızı gözlerinizle takip etmesi zor olacak kadar hızlı çalıştırır.',
        description: 'description for the "slow it down" section of the debug modal'
    },
    slowItDownDescription2: {
        id: 'gui.debugModal.slowItDown.description2',
        defaultMessage: 'Dizileri yavaşlatmak için geçici "bekle" veya "bekle" blokları ekleyin. Bu, bir parçanın çalışıp çalışmadığını görmek için size zaman tanır.',
        description: 'description for the "slow it down" section of the debug modal'
    },
    slowItDownDescription3: {
        id: 'gui.debugModal.slowItDown.description3',
        defaultMessage: 'Kodunuz çalışır hale gelince bu bekle bloklarını kaldırın.',
        description: 'description for the "slow it down" section of the debug modal'
    },
    addSoundCheckpointsTitle: {
        id: 'gui.debugModal.addSoundCheckpoints.title',
        defaultMessage: 'Ses Kontrol Noktaları Ekle',
        description: 'title for the "add sound checkpoints" section'
    },
    addSoundCheckpointsDescription1: {
        id: 'gui.debugModal.addSoundCheckpoints.description1',
        defaultMessage: 'Yavaşlatma stratejisine benzer şekilde, dizinizi test etmek için anahtar noktalara "bitene kadar çal" bloğu ile farklı sesler ekleyebilirsiniz.',
        description: 'description for the "add sound checkpoints" section of the debug modal'
    },
    addSoundCheckpointsDescription2: {
        id: 'gui.debugModal.addSoundCheckpoints.description2',
        defaultMessage: 'Bir ses çalmazsa, hatanız bu bloktan önce olabilir. Ses çalıyorsa, hata muhtemelen bu bloktan sonradır.',
        description: 'description for the "add sound checkpoints" section of the debug modal'
    },
    addSoundCheckpointsDescription3: {
        id: 'gui.debugModal.addSoundCheckpoints.description3',
        defaultMessage: 'Kodunuz çalışır hale gelince sesleri kaldırın.',
        description: 'description for the "add sound checkpoints" section of the debug modal'
    },
    tinkerWithBlockOrderTitle: {
        id: 'gui.debugModal.tinkerWithBlockOrder.title',
        defaultMessage: 'Blok Sırasını Değiştir',
        description: 'title for the "tinker with block order" section'
    },
    tinkerWithBlockOrderDescription1: {
        id: 'gui.debugModal.tinkerWithBlockOrder.description1',
        defaultMessage: 'Blokların sırasını/dizisini ayarlamayı deneyin.',
        description: 'description for the "tinker with block order" section of the debug modal'
    },
    tinkerWithBlockOrderDescription2: {
        id: 'gui.debugModal.tinkerWithBlockOrder.description2',
        defaultMessage: 'Önce ne olması gerekiyor?',
        description: 'description for the "tinker with block order" section of the debug modal'
    },
    tinkerWithBlockOrderDescription3: {
        id: 'gui.debugModal.tinkerWithBlockOrder.description3',
        defaultMessage: 'İkinci olarak ne oluyor?',
        description: 'description for the "tinker with block order" section of the debug modal'
    },
    tinkerWithBlockOrderDescription4: {
        id: 'gui.debugModal.tinkerWithBlockOrder.description4',
        defaultMessage: 'Bir sonraki kod çalışmadan önce değerlerin veya kuklalar sıfırlanması gerekiyor mu?',
        description: 'description for the "tinker with block order" section of the debug modal'
    },
    tinkerWithBlockOrderDescription5: {
        id: 'gui.debugModal.tinkerWithBlockOrder.description5',
        defaultMessage: 'Blokları bir döngü veya koşullu ifade içinde kullanmayı, döngü veya koşullu ifade dışında kullanmaya karşı deneyin.',
        description: 'description for the "tinker with block order" section of the debug modal'
    },
    toLoopOrNotTitle: {
        id: 'gui.debugModal.toLoopOrNot.title',
        defaultMessage: 'Döngü Kullanmak ya da Kullanmamak',
        description: 'title for the "tinker with block order" section'
    },
    toLoopOrNotDescription1: {
        id: 'gui.debugModal.toLoopOrNot.description1',
        defaultMessage: '"Sürekli" ve "tekrarla" gibi Kontrol blokları kullanıyorsanız, bir döngü içindeki tüm blokların orada olması gerekip gerekmediğini veya işlemi sıfırlamak veya zamanlamayı ayarlamak için bir bloğun (örneğin "bekle") eksik olup olmadığını kontrol edin. Döngünüzün sonsuza kadar mı yoksa belirli sayıda kez mi çalışmasını istiyorsunuz? Döngülemeyi durduracak bir şey olmalı mı?',
        description: 'description for the "to loop or not to loop" section of the debug modal'
    },
    toLoopOrNotDescription2: {
        id: 'gui.debugModal.toLoopOrNot.description2',
        defaultMessage: 'Belki de kullanmanız gereken bir döngü kullanmıyorsunuz? Örneğin, "eğer o zaman" gibi bir koşullu ifade bloğu kullanıyorsanız, program bunun doğru mu yanlış mı olduğunu yalnızca bir kez mi kontrol etmeli? Yoksa sürekli olarak kontrol etmesi mi gerekiyor, bu durumda koşullu ifadenizi sonsuz bir döngü içine mi koymak istersiniz?',
        description: 'description for the "to loop or not to loop" section of the debug modal'
    },
    timingAndParallelismTitle: {
        id: 'gui.debugModal.timingAndParallelism.title',
        defaultMessage: 'Zamanlama ve Paralellik Üzerine Düşün',
        description: 'title for the "think about timing and parallelism" section'
    },
    timingAndParallelismSectionTitle: {
        id: 'gui.debugModal.timingAndParallelism.sectionTitle',
        defaultMessage: 'Zamanlama ve Paralellik',
        description: 'title for the "think about timing and parallelism" sidebar section'
    },
    timingAndParallelismDescription1: {
        id: 'gui.debugModal.timingAndParallelism.description1',
        defaultMessage: 'Aynı anda çalışmaya çalışan birden fazla olayınız var mı? İki dizi aynı anda başlayacak şekilde programlandıysa, tahmin edilemeyen davranışlar elde edebilirsiniz.',
        description: 'description for the "think about timing and parallelism" section of the debug modal'
    },
    timingAndParallelismDescription2: {
        id: 'gui.debugModal.timingAndParallelism.description2',
        defaultMessage: 'Bunun sonucu etkileyip etkilemediğini görmek için küçük beklemeler, yayınlar veya kullanıcı etkileşimi (tıklama veya bir tuşa basma gibi) ekleyin.',
        description: 'description for the "think about timing and parallelism" section of the debug modal'
    },
    thinkAboutBlockOptionsTitle: {
        id: 'gui.debugModal.thinkAboutBlockOptions.title',
        defaultMessage: 'Blok Seçenekleri Üzerine Düşün',
        description: 'title for the "think about block options" section'
    },
    thinkAboutBlockOptionsDescription1: {
        id: 'gui.debugModal.thinkAboutBlockOptions.description1',
        defaultMessage: 'Kullanabileceğiniz benzer ama farklı bir blok var mı?',
        description: 'description for the "think about block options" section of the debug modal'
    },
    thinkAboutBlockOptionsDescription2: {
        id: 'gui.debugModal.thinkAboutBlockOptions.description2',
        defaultMessage: 'Bazı bloklar benzer görünür ancak farklı davranabilir, örneğin "ayarla" ve "değiştir" veya "bitene kadar çal" ve "başlat" gibi.',
        description: 'description for the "think about block options" section of the debug modal'
    },
    thinkAboutBlockOptionsDescription3: {
        id: 'gui.debugModal.thinkAboutBlockOptions.description3',
        defaultMessage: 'Sahip olduğunuzun yerine benzer bir blok kullanmayı deneyin ve bunun sonucu etkileyip etkilemediğini görün.',
        description: 'description for the "think about block options" section of the debug modal'
    },
    checkTheValuesTitle: {
        id: 'gui.debugModal.checkTheValues.title',
        defaultMessage: 'Değerleri Kontrol Et',
        description: 'title for the "check the value" section'
    },
    checkTheValuesDescription1: {
        id: 'gui.debugModal.checkTheValues.description1',
        defaultMessage: 'Değişkenler veya raportör blokları kullanıyorsanız, kod dizisi çalıştırıldığı anda değeri kontrol edin.',
        description: 'description for the "check the values" section of the debug modal'
    },
    checkTheValuesDescription2: {
        id: 'gui.debugModal.checkTheValues.description2',
        defaultMessage: 'Tüm kuklaların bir değişkeni kontrol etmesi mi gerekiyor, yoksa sadece bir kuklanın mı kontrolü olmalı?',
        description: 'description for the "check the values" section of the debug modal'
    },
    checkTheValuesDescription3: {
        id: 'gui.debugModal.checkTheValues.description3',
        defaultMessage: 'Değer nerede sıfırlanıyor? Nerede değiştiriliyor?',
        description: 'description for the "check the values" section of the debug modal'
    },
    checkCodeSequenceTitle: {
        id: 'gui.debugModal.checkCodeSequence.title',
        defaultMessage: 'Kod Dizisini Kontrol Et',
        description: 'title for the "check code sequence" section'
    },
    checkCodeSequenceDescription1: {
        id: 'gui.debugModal.checkCodeSequence.description1',
        defaultMessage: 'Kod dizinizin doğru kuklaya veya uygunsa arka plana eklendiğinden emin olun.',
        description: 'description for the "check code sequence" section of the debug modal'
    },
    checkCodeSequenceDescription2: {
        id: 'gui.debugModal.checkCodeSequence.description2',
        defaultMessage: 'Kodunuzu başka bir kuklaya taşımanız gerekiyorsa, doğru kuklanın üzerinde gezinene kadar tıklayıp sürükleyin. Kukla sallanınca bırakın.',
        description: 'description for the "check code sequence" section of the debug modal'
    },
    checkCodeSequenceDescription3: {
        id: 'gui.debugModal.checkCodeSequence.description3',
        defaultMessage: 'Kodunuzu veya varlıklarınızı saklamak ve taşımak için Sırt Çantanızı da (ekranın altında) kullanabilirsiniz.',
        description: 'description for the "check code sequence" section of the debug modal'
    },
    commentYourCodeTitle: {
        id: 'gui.debugModal.commentYourCode.title',
        defaultMessage: 'Kodunuzu Yorumlayın',
        description: 'title for the "comment your code" section'
    },
    commentYourCodeDescription1: {
        id: 'gui.debugModal.commentYourCode.description1',
        defaultMessage: 'Kodunuza yorum eklemek, kodunuza bakan diğer kişilerin onu anlamasına yardımcı olabilir. Ayrıca daha sonra kodunuza döndüğünüzde nasıl çalıştığını hatırlamanıza da yardımcı olabilir.',
        description: 'description for the "comment your code" section of the debug modal'
    },
    commentYourCodeDescription2: {
        id: 'gui.debugModal.commentYourCode.description2',
        defaultMessage: 'Kodunuzu bölümlere ayırmak ve her bölümün ne yaptığını açıklamak yararlı olabilir.',
        description: 'description for the "comment your code" section of the debug modal'
    },
    takeABreakTitle: {
        id: 'gui.debugModal.takeABreak.title',
        defaultMessage: 'Ara Ver',
        description: 'title for the "take a break" section'
    },
    takeABreakDescription1: {
        id: 'gui.debugModal.takeABreak.description1',
        defaultMessage: 'Bazen en iyi yaklaşım, ara vermek ve kafa temizliğidir!',
        description: 'description for the "take a break" section of the debug modal'
    },
    takeABreakDescription2: {
        id: 'gui.debugModal.takeABreak.description2',
        defaultMessage: 'Daha sonra projene taze bir bakış açısıyla dönebilirsin.',
        description: 'description for the "take a break" section of the debug modal'
    },
    askForHelpTitle: {
        id: 'gui.debugModal.askForHelp.title',
        defaultMessage: 'Yardım İste',
        description: 'title for the "ask for help" section'
    },
    askForHelpDescription1: {
        id: 'gui.debugModal.askForHelp.description1',
        defaultMessage: 'Bir arkadaştan, öğretmenden veya aile üyesinden yardım istemekten çekinme.',
        description: 'description for the "ask for help" section of the debug modal'
    },
    askForHelpDescription2: {
        id: 'gui.debugModal.askForHelp.description2',
        defaultMessage: 'Bazen yeni bir bakış açısı, göremediğiniz sorunları görmenize yardımcı olabilir.',
        description: 'description for the "ask for help" section of the debug modal'
    }
};

// Ana modal başlığı için çeviri
export const trModalTitle = {
    title: {
        id: 'gui.debugModal.title',
        defaultMessage: 'Hata Ayıklama | Takılmaktan Kurtulma',
        description: 'title for the debugging modal'
    }
};

// Menü bar için çeviri
export const trMenuBar = {
    tutorials: {
        id: 'gui.menuBar.tutorialsLibrary',
        defaultMessage: 'Dersler',
        description: 'accessibility text for the tutorials button'
    },
    debug: {
        id: 'gui.menuBar.debug',
        defaultMessage: 'Hata Ayıklama',
        description: 'accessibility text for the debug button'
    },
    addDevice: {
        id: 'gui.menuBar.addDevice',
        defaultMessage: 'Cihaz Ekle',
        description: 'accessibility text for the add device button'
    }
};

// Cihaz Bağlantı Modalı için Türkçe çeviriler
export const trConnectionModal = {
    scanning: {
        defaultMessage: 'Cihazlar Aranıyor',
        description: 'Text shown during device scanning phase'
    },
    connect: {
        defaultMessage: 'Bağlan',
        description: 'Button to connect to a device'
    },
    connecting: {
        defaultMessage: 'Bağlanıyor',
        description: 'Text shown during device connection phase'
    },
    connected: {
        defaultMessage: 'Bağlandı',
        description: 'Text shown when device is connected'
    },
    disconnect: {
        defaultMessage: 'Bağlantıyı Kes',
        description: 'Button to disconnect a device'
    },
    error: {
        defaultMessage: 'Bağlantı Hatası',
        description: 'Text shown when device connection fails'
    },
    noDevicesFound: {
        defaultMessage: 'Hiçbir cihaz bulunamadı',
        description: 'Text shown when no devices are found'
    },
    selectDevice: {
        defaultMessage: 'Cihazınızı listeden seçin.',
        description: 'Prompt for choosing a device to connect to'
    },
    tryAgain: {
        defaultMessage: 'Tekrar Dene',
        description: 'Button to try again after connection failure'
    },
    installScratchLink: {
        defaultMessage: 'Cihazlara bağlanmak için Scratch Link programının kurulu olduğundan emin olun.',
        description: 'Suggestion to install Scratch Link to connect devices'
    },
    enableBluetooth: {
        defaultMessage: 'Bluetooth\'un açık olduğundan emin olun.',
        description: 'Suggestion to enable Bluetooth'
    },
    scratchLinkNotFound: {
        defaultMessage: 'Scratch Link bulunamadı',
        description: 'Error message when Scratch Link is not found'
    },
    updateFirmware: {
        defaultMessage: 'Aygıt yazılımını güncelle',
        description: 'Button to update firmware of a device'
    },
    updateInProgress: {
        defaultMessage: 'Güncelleme sürüyor...',
        description: 'Text shown during firmware update'
    },
    updateComplete: {
        defaultMessage: 'Güncelleme tamamlandı!',
        description: 'Text shown when firmware update is complete'
    },
    updateFailed: {
        defaultMessage: 'Güncelleme başarısız oldu. Lütfen tekrar deneyin.',
        description: 'Text shown when firmware update fails'
    }
}; 